import { useMemo } from "react";
import { buildMenuTree, flattenMenuPaths } from "@/routes";
import { useSystemMenu } from "./useSystemMenu";

/**
 * Conjunto de paths que o usuário logado pode acessar, derivado da mesma árvore do menu lateral
 * (request 116/`buildMenuTree`) — usado tanto pelo `MenuAccessGuard` (bloquear rota/aba fora do menu)
 * quanto por qualquer tela que precise decidir se mostra um atalho para uma ação (ex. Dashboard: não
 * exibir um botão para uma tela que o usuário não tem permissão de abrir).
 */
export const useAllowedMenuPaths = () => {
  const { data: systemMenu, isLoading } = useSystemMenu();
  const allowedPaths = useMemo(() => flattenMenuPaths(buildMenuTree(systemMenu?.System?.Menus ?? [])), [systemMenu]);
  return { allowedPaths, isLoading };
};
